import TimeConstants from 'owa-datetime-utils/lib/TimeConstants';
import { action } from 'satcheljs/lib/legacy';
import type { CalendarPrintViewSettings } from '.';
import type { CalendarSurfaceStore } from 'owa-calendar-surface-dategrid';
import { createDateRangeFromType } from 'owa-datetime-utils';

export default action('createCalendarSurfaceStoreFromPrintViewSettings')(
    function createCalendarSurfaceStoreFromPrintViewSettings<TEvent>(
        settings: CalendarPrintViewSettings<TEvent>,
        store: CalendarSurfaceStore
    ) {
        store.enableDragDrop = false;

        const { calendarView } = settings;
        const {
            date,
            view,
            fromHour,
            toHour,
            firstDayOfWeek,
            workWeekDays,
            showWeekNumbers,
            firstWeekOfYear,
            numDaysInDayRange,
        } = calendarView;

        store.dateRange = createDateRangeFromType(
            view,
            date,
            firstDayOfWeek,
            workWeekDays,
            numDaysInDayRange
        );
        store.dateRangeType = view;
        store.dayStartMinute = fromHour * TimeConstants.MinutesInOneHour;
        store.dayLength = (toHour - fromHour) * TimeConstants.MinutesInOneHour;

        store.userOptions.weekStartDay = firstDayOfWeek;
        store.userOptions.workDays = workWeekDays;
        store.userOptions.showWeekNumbers = showWeekNumbers;
        store.userOptions.firstWeekOfYear = firstWeekOfYear;

        const { events, getSurfaceItemModel, isRTL } = settings;
        store.userOptions.isRTL = isRTL;
        store.calendarItems = events.map(getSurfaceItemModel);
        store.monthHeight = 0;
    }
);
